var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-stores"}},[_c('block-header-standard',{attrs:{"title":this.title[_vm.locale]}}),_c('store-list-grid',{attrs:{"categories":_vm.$store.getters.storeFilters,"categoryId":['5b9d3c6062973c001fd2c699','5b9d3c1f62973c001fd2c698']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }